import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import moment from "moment";

/**
 * Generated class for the DateParagraphComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "date-paragraph",
  templateUrl: "date-paragraph.html",
})
export class DateParagraphComponent implements OnInit {
  // Configuration properties
  @Input() group: FormGroup;
  @Input() config;

  // Internal data model
  id: string;
  componentId: string;
  label: any;
  disabled: boolean;
  readonly: boolean = false;

  date: string;
  startDate: string;
  endDate: string;
  pretext: string;
  posttext: string;

  constructor(public formBuilder: FormBuilder) {
    // console.log('Hello DateParagraphComponent Component');
  }

  ngOnInit(): void {
    let config = this.config;

    this.id = config.id;
    this.componentId = this.config.componentId;
    this.label = config.label !== undefined ? config.label : config.id;
    if (this.label === "false") {
      this.label = false;
    }
    this.readonly = this.config.readonly;
    this.pretext = this.config.pretext;
    this.posttext = this.config.posttext;

    // Outer form state
    this.group.addControl(this.id, this.formBuilder.control(null));

    // set the start and end dates, if any
    let rules = this.config.rules,
      validators = [];
    if (rules) {
      if (rules.required) {
        validators.push(Validators.required);
      }

      if (rules.startDate) {
        this.startDate = this.getDate(rules.startDate);
      }
      if (rules.endDate) {
        this.endDate = this.getDate(rules.endDate);
      } else {
        this.endDate = this.getDate("decadeFromToday");
      }
    }

    this.group.controls[this.id].valueChanges.subscribe((data) => {
      this.importOuterValue(data);
      this.disabled = this.group.controls[this.id].disabled;
    });
    let value = moment.utc(new Date()).local().format("YYYYMMDD");
    this.group.controls[this.id].setValue(value);
  }

  getDate(dateStr): string {
    switch (dateStr) {
      case "decadeFromToday":
        return moment().add("10", "years").format("YYYY-MM-DD");
      case "today":
      default:
        return moment().format("YYYY-MM-DD");
    }
  }

  exportInnerValue() {
    // console.log( "Exporting inner value: ", this.date );

    let value = moment(this.date, "YYYY-MM-DD").format("YYYYMMDD");
    value = moment(value, "YYYYMMDD").format("YYYYMMDD");

    this.group.controls[this.id].setValue(value);
  }

  importOuterValue(data: string) {
    // console.log( "Importing outer value: ", data );

    this.date = moment(data, "YYYYMMDD").format("YYYY-MM-DD");
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/date-paragraph/date-paragraph.ts